import React from 'react'
import Helmet from 'react-helmet'
import cx from 'classnames'
import Footer from 'components/Footer'
import { observable, action, computed } from 'mobx'
import { observer } from 'mobx-react'
import { validationContext, required, pattern } from 'validx'
import { Form, Input } from 'components/Form'
import { task } from 'mobx-task'
import BodyClass from 'react-body-classname'
import hideIntercom from 'decorators/hideIntercom'
import Link from 'components/Link'
import links from 'misc/links'

import './styles.sass'

export const sweepstakes = [{
  path: '/mileiq-sweepstakes',
  title: 'Taxfyle + MileIQ Sweepstakes',
  campaign: 'GREAT TAX PREP GIVEAWAY 2017',
  logo: 'mileiq-taxfyle.png',
  logoWidth: '70%',
  coupon: 'MILEIQ30',
  termsId: 'mileiq',
  startDate: 'March 6, 2017',
  endDate: 'March 19, 2017',
  prizeDate: 'March 20, 2017',
  partnerId: 'mileiq',
  grand: '<p>5 lucky winners will receive <strong>free</strong> tax preparation and filings from a Tax Pro <strong>for life</strong>. Never worry about taxes again!</p>',
  grandLegal: 'five (5) winners to receive free individual tax preparation services for life via the Taxfyle Platform',
  second: '<p>50 lucky winners will have their 2016 taxes filed for them free of charge!</p>',
  secondLegal: 'fifty (50) winners to receive free 2016 individual tax preparation services the Taxfyle Platform',
  everyone: '<p>All MileIQ members receive <strong>$30 off</strong> tax filing fees. Simply use promo code: <strong>MILEIQ30</strong> at checkout.</p>',
  limitations: 'Prizes are limited to individual returns, not exceeding $500 cost per year.'
}, {
  path: '/dharma-sweepstakes',
  title: 'Taxfyle + Dharma Merchant Services Sweepstakes',
  campaign: 'DHARMA TAX PREP GIVEAWAY 2017',
  beforeLogo: '<div style="text-align:center;width:40%;margin:0.5em auto"><img src="https://taxfyle-benefits-images.s3.amazonaws.com/1481642502767/taxfyle-logo-blue%20%282%29.png" alt="taxfyle" /><br />+</div>',
  logo: 'https://taxfyle-benefits-images.s3.amazonaws.com/1476458455612/Benefits%20and%20Promo.png',
  coupon: 'DHARMA30',
  termsId: 'standard',
  startDate: 'March 24, 2017',
  endDate: 'April 9, 2017',
  prizeDate: 'April 10, 2017',
  partnerId: 'dharma',
  grand: '<p>3 lucky winners will receive <strong>free</strong> tax preparation and filings from a Tax Pro <strong>for life</strong>. Never worry about taxes again!</p>',
  grandLegal: 'three (3) winners to receive free individual tax preparation services for life via the Taxfyle Platform',
  second: '<p>10 lucky winners will have their 2016 taxes filed for them free of charge!</p>',
  secondLegal: 'ten (10) winners to receive free 2016 individual tax preparation services the Taxfyle Platform',
  everyone: '<p>All Dharma Merchant Services members receive <strong>$30 off</strong> tax filing fees. Simply use promo code: <strong>DHARMA30</strong> at checkout.</p>',
  limitations: 'Prizes are limited to individual returns, not exceeding $500 cost per year.'
}]

@hideIntercom
@observer
export default class SweepstakesScreen extends React.Component {
  componentWillMount () {
    this.vm = new SweepstakesViewModel({
      rootStore: this.props.rootStore,
      coupon: this.props.route.coupon,
      referrer: this.props.route.path.replace('/', '').replace(/\//g, '-')
    })
  }

  login = () => {
    return this.vm.login().then(this.afterAuthenticate)
  }

  signup = () => {
    return this.vm.signup().then(this.afterAuthenticate)
  }

  render () {
    const vm = this.vm
    const formDisabled = vm.formDisabled
    const TermsComponent = require(`./Terms/${this.props.route.termsId}/index.jsx`).default
    const referrer = this.props.route.path.replace('/', '').replace(/\//g, '-')
    return (
      <div className="sweepstakes-screen">
        <Helmet title={this.props.route.title} />
        <BodyClass className="login" />
        <div className="sweepstakes-container">
          <div className="sweepstakes-hero">
            <div className="banner">
              <a href="#learn-more" className="action-button">Enter to win</a>
            </div>
            <div className="logo-area">
              <div className="prize-description" dangerouslySetInnerHTML={{__html: this.props.route.beforeLogo}} />
              <img style={{maxWidth: (this.props.route.logoWidth || '40%'), marginBottom: '2em'}} src={this.props.route.logo.indexOf('http') === 0 ? this.props.route.logo : require('./img/' + this.props.route.logo)} alt={this.props.route.title} />
            </div>
          </div>

          <div className="prizes">
            <div className="columns">
              <div className="column is-8 is-offset-2">
                <Prize title="Grand Prize" description={this.props.route.grand} />
                <Prize title="Second Place" description={this.props.route.second} />
                <Prize title="Everyone Wins" description={this.props.route.everyone} />
              </div>
            </div>
          </div>

          <div id="learn-more" className="learn-more">
            <div className="columns">
              <div className="column is-8 is-offset-2" style={{textAlign: 'center'}}>
                <p className="prize-title">Why is Taxfyle for you?</p>
                <p className="prize-description">Maximize your refund with Taxfyle 💰</p>
                <div className="button-container">
                  {this.props.route.partnerId === undefined
                    ? <a href={'https://app.taxfyle.com/?ref=sweepstakes&utm_source=' + referrer} className="action-button">Learn more</a>
                    : <a href={'https://taxfyle.com/partners/' + this.props.route.partnerId} className="action-button">Learn more</a>
                  }
                </div>
              </div>
            </div>
          </div>

          {vm.done
            ? (
              <div className="thanks-box">
                <p className="thanks-box__text">
                  Thank you for entering!
                </p>
                <div className="thanks-box__buttons">
                  <Link className="button is-hero-auth-button" to={links.projects()}>
                    <span>Let's file your taxes</span>
                  </Link>
                </div>
              </div>
            )
            : (
              <div className="submit-form">
                <div className="columns">
                  <div className="column is-10 is-offset-1 prize-steps">
                    <ol>
                      <li>
                        <strong>Sign up</strong> with Taxfyle
                        <div className="signup-container">
                          <a className="button signup-button is-primary" onClick={formDisabled && this.signup} disabled={!formDisabled}>
                            {formDisabled ? 'Sign up' : 'Thanks for signing up!'}
                          </a>
                        </div>
                      </li>
                      <li>
                        Enter the information on the form below
                        <div className="form-container">
                          <Form onSubmit={() => vm.submit()}>
                            <Input disabled={formDisabled || vm.submit.pending} model={vm} field="first_name" label="First name" />
                            <Input disabled={formDisabled || vm.submit.pending} model={vm} field="last_name" label="Last name" />
                            <Input disabled={formDisabled || vm.submit.pending} model={vm} field="email" type="email" label="E-mail" />
                            <button disabled={formDisabled || vm.submit.pending} className={cx('button', formDisabled || 'is-primary')}>
                              {formDisabled ? 'Please sign up first' : 'Submit'}
                            </button>
                          </Form>
                        </div>
                      </li>
                      <li>Check <a href="https://twitter.com/taxfyle">@taxfyle</a> on Twitter for winners <strong>{this.props.route.prizeDate}!</strong></li>
                    </ol>
                  </div>
                </div>
              </div>
            )
          }

          {/* Sweepstakes Terms */}
          <div className="container prize-terms">
            <TermsComponent {...this.props.route} />
          </div>

        </div>

        <div className="container">
          <div className="columns">
            <div className="column has-spacing-top has-spacing-bottom">
              <Footer />
            </div>
          </div>
        </div>
      </div>
    )
  }
}

const Prize = ({ title, description }) => (
  <div className="prize">
    <div className="prize-title">
      {title}
    </div>
    <div className="prize-description" dangerouslySetInnerHTML={{__html: description}} />
  </div>
)

/* eslint-disable */
class SweepstakesViewModel {
  @observable first_name = ''
  @observable last_name = ''
  @observable email = ''
  @observable user_id = ''
  @observable done = false

  validation = validationContext()

  constructor ({ rootStore, coupon, referrer }) {
    this.coupon = coupon
    this.rootStore = rootStore
    this.afterAuth = this.afterAuth.bind(this)
    this.rootStore.authStore.setReferrerMeta({ referrer: referrer })
  }

  @computed get formDisabled () {
    return !this.user_id
  }

  login () {
    return this.rootStore.authStore.login().then(this.afterAuth)
  }

  signup () {
    return this.rootStore.authStore.signup({ hideLogin: true }).then(this.afterAuth)
  }

  @action afterAuth () {
    const { user } = this.rootStore.authStore
    if (!user) {
      return false
    }

    this.user_id = user.id
    this.email = user.email
    return true
  }

  @task.resolved async submit () {
    const rules = {
      first_name: [required('First name is required.')],
      last_name: [required('Last name is required.')],
      email: [required('E-mail is required'), pattern({ pattern: 'email', msg: 'Not a valid e-mail.' })]
    }
    if (!this.validation.reset().validate(this, rules).isValid) {
      return
    }

    return await this.rootStore.api.sweep.create({
      user_id: this.user_id,
      first_name: this.first_name,
      last_name: this.last_name,
      email: this.email,
    })
    .then(() => {
      const data = {
        given_name: this.first_name,
        family_name: this.last_name,
        email_address: this.email
      }
      return this.rootStore.api.profiles.patch('me', data)
        .then(action(this.rootStore.userStore.users.set))
    })
    .then(() => {
      if (!this.coupon) {
        return
      }

      return this.rootStore.couponStore.addCoupon(this.coupon)
        .catch(() => {})
    })
    .then(action(() => {
      this.done = true
    }))
  }
}
/* eslint-enable */



// WEBPACK FOOTER //
// ./src/client/screens/Sweepstakes/index.jsx